module.exports = __webpack_public_path__ + "static/media/no-symptoms.01c6d097.svg";